<template>
  <div class="grid grid-flow-row gap-4 lg:px-8">
    <div class="flex justify-center min-height-auto">
      <h1 class="text-3xl text-center font-bold leading-none tracking-tight text-gray-900 md:text-3xl lg:text-3xl">
        Presupuestos
      </h1>
    </div>
    <span>
      <svg class="w-5 h-5 inline-block text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
          d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z" />
      </svg>
      Filtro por fecha:
    </span>
    <div class="grid grid-cols-2 lg:grid-cols-5 gap-3">
      <div>
        <input type="date" v-model="fechaInicio"
          class="w-full form-control block px-3 py-2 border border-gray-300 rounded-md text-gray-700 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500" />
      </div>
      <div>
        <input type="date" v-model="fechaFin"
          class="w-full form-control block px-3 py-2 border border-gray-300 rounded-md text-gray-700 bg-white appearance-none cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500" />
      </div>
      <div>
        <button type="button" @click="filtrarPorFecha"
          class="w-full text-white bg-[#3edfa9] hover:bg-[#ffe068] font-medium rounded-lg text-sm px-2 md:px-5 py-2.5">
          <svg class="w-6 h-6 inline-block text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
            height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4" />
          </svg>
          Filtrar
        </button>
      </div>
      <div v-if="filtrosActivos">
        <button type="button" @click="resetearFiltros"
          class="w-full text-white bg-red-500 hover:bg-red-600 font-medium rounded-lg text-sm px-2 md:px-5 py-2.5">
          <svg class="w-6 h-6 inline-block text-white" viewBox="0 0 32 32" version="1.1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="none">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <title>cross-circle</title>
              <desc>Created with Sketch Beta.</desc>
              <defs></defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-568.000000, -1087.000000)"
                  fill="#fff">
                  <path
                    d="M584,1117 C576.268,1117 570,1110.73 570,1103 C570,1095.27 576.268,1089 584,1089 C591.732,1089 598,1095.27 598,1103 C598,1110.73 591.732,1117 584,1117 L584,1117 Z M584,1087 C575.163,1087 568,1094.16 568,1103 C568,1111.84 575.163,1119 584,1119 C592.837,1119 600,1111.84 600,1103 C600,1094.16 592.837,1087 584,1087 L584,1087 Z M589.717,1097.28 C589.323,1096.89 588.686,1096.89 588.292,1097.28 L583.994,1101.58 L579.758,1097.34 C579.367,1096.95 578.733,1096.95 578.344,1097.34 C577.953,1097.73 577.953,1098.37 578.344,1098.76 L582.58,1102.99 L578.314,1107.26 C577.921,1107.65 577.921,1108.29 578.314,1108.69 C578.708,1109.08 579.346,1109.08 579.74,1108.69 L584.006,1104.42 L588.242,1108.66 C588.633,1109.05 589.267,1109.05 589.657,1108.66 C590.048,1108.27 590.048,1107.63 589.657,1107.24 L585.42,1103.01 L589.717,1098.71 C590.11,1098.31 590.11,1097.68 589.717,1097.28 L589.717,1097.28 Z"
                    id="cross-circle" sketch:type="MSShapeGroup"></path>
                </g>
              </g>
            </g>
          </svg>
          Resetear Filtros
        </button>
      </div>
      <div>
        <router-link to="/formpresupuesto">
          <button type="button"
            class="w-full focus:outline-none text-white bg-[#3edfa9] hover:bg-[#ffe068] focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-2 md:px-5 py-2.5">
            <svg class="w-6 h-6 inline-block text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            Agregar
          </button></router-link>
      </div>
      <div>
        <form>
          <select v-model="itemsPorPagina" @change="cambiarItemsPorPagina"
            class="bg-gray-50 border border-[#3edfa9] text-gray-900 text-sm rounded-lg focus:ring-[#3edfa9] focus:border-[#3edfa9] block w-full p-2.5">
            <option value="10">Mostrar 10 resultados</option>
            <option value="20">Mostrar 20 resultados</option>
            <option value="30">Mostrar 30 resultados</option>
            <option value="50">Mostrar 50 resultados</option>
          </select>
        </form>
      </div>
    </div>
    <hr class="divide-y divide-gray-100" />
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
      <table class="w-full text-sm text-left rtl:text-right text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-[#96ffdf]">
          <tr>
            <th scope="col" class="px-4 py-3">Fecha</th>
            <th scope="col" class="px-4 py-3">#Presupuesto</th>
            <th scope="col" class="px-4 py-3">Nombre cliente</th>
            <th scope="col" class="px-4 py-3">Servicios</th>
            <th scope="col" class="px-4 py-3">Total</th>
            <th scope="col" class="px-4 py-3">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="presupuesto in presupuestosPaginados" :key="presupuesto.id" class="bg-white border-b">
            <th scope="row" class="px-4 py-4 font-medium text-gray-900 whitespace-nowrap">
              {{ formatFecha(presupuesto.fechaCreacion) }}
            </th>
            <td class="px-4 py-4">
              {{ presupuesto.codigo }}
            </td>
            <td class="px-4 py-4">
              {{ presupuesto.nombre }}
            </td>
            <td class="px-4 py-4">
              <ul class="max-w-md space-y-1 text-gray-500 list-none list-inside">
                <li v-for="(detalle, index) in presupuesto.detalles" :key="index">
                  {{ detalle.servicio.nombre }}
                </li>
              </ul>
            </td>
            <td class="px-4 py-4">
              ${{ formatMoney(calcularTotalPresupuesto(presupuesto.detalles)) }}
            </td>
            <td
              class="grid lg:flex md:flex lg:items-center md:items-center px-2 md:px-2 py-4 lg:text-left md:text-center">
              <!-- <router-link :to="`/editar-presupuesto/${presupuesto.id}`"
                class="font-regular text-xs text-gray-800 hover:underline">
                <svg class="w-4 h-4 inline-block text-gray-800 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z" />
                </svg>
                Editar
              </router-link> -->
              <a href="#" @click="deleteModal(presupuesto.id)"
                class="font-medium text-xs text-red-500 hover:underline lg:ml-2">
                <svg class="w-4 h-4 inline-block text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="none" viewBox="0 0 24 24">
                  <path stroke="#ef4444" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z" />
                </svg>
                Eliminar
              </a>

              <a href="#" @click="generarPDF(presupuesto, { loggedUser })"
                class="font-medium text-xs text-gray-800 hover:underline lg:ml-2">
                <svg class="w-4 h-4 inline-block text-gray-800 dark:text-white" aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-width="2"
                    d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
                  <path stroke="currentColor" stroke-width="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>

                Detalle
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="pdf-template" style="position: absolute; left: -9999px; width: 210mm;">
      <div ref="pdfContent" class="pdf-content p-8" style="font-family: Arial, sans-serif;">
        <!-- Contenido dinámico se insertará aquí -->
      </div>
    </div>



    <!-- Paginación -->
    <div class="flex justify-center mt-4">
      <nav class="inline-flex rounded-md shadow">
        <button @click="paginaAnterior" :disabled="paginaActual === 1"
          class="px-3 py-1 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50">
          Anterior
        </button>
        <button v-for="page in totalPaginas" :key="page" @click="irAPagina(page)"
          :class="{ 'bg-[#3edfa9] text-white': paginaActual === page, 'bg-white text-gray-700': paginaActual !== page }"
          class="px-3 py-1 border-t border-b border-gray-300 text-sm font-medium">
          {{ page }}
        </button>
        <button @click="paginaSiguiente" :disabled="paginaActual === totalPaginas"
          class="px-3 py-1 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50">
          Siguiente
        </button>
      </nav>
    </div>

    <Modal message="Registro" @confirm="eliminarPresupuesto" ref="modalComponent" />
  </div>
</template>

<script>
import presupuestoService from "../../composables/api/presupuestoService";
import authService from "../../composables/api/authService.js";
import tenantService from "../../composables/api/tenantService.js";
import { ref, onMounted, computed } from "vue";
import Modal from "../modalConfirmar/ModalConfirmar.vue";
import { jsPDF } from "jspdf";

export default {
  components: { Modal },
  setup() {
    const presupuestos = ref([]);
    const fechaInicio = ref('');
    const fechaFin = ref('');
    const filtrosActivos = ref(false);
    const itemsPorPagina = ref(10);
    const paginaActual = ref(1);
    const modalComponent = ref(null);
    const modal = ref();

    // 🔹 Usuario + Tenant (como en Ventas)
    const currentUser = ref(null);
    const tenantInfo = ref(null);
    const loadUsuarioYTenant = async () => {
      try {
        const user = await authService.getCurrentUser();
        currentUser.value = user || null;
        if (user?.tenantId != null) {
          const t = await tenantService.getTenantByTenantId(user.tenantId);
          tenantInfo.value = t || null;
        } else {
          tenantInfo.value = null;
        }
      } catch (e) {
        console.error("Error al cargar usuario/tenant", e);
      }
    };

    // ===== Helpers ya presentes =====
    const formatMoney = (value) =>
      parseFloat(value || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    const formatFecha = (fecha) => fecha.toLocaleDateString('es-ES');
    const calcularTotalPresupuesto = (detalles) =>
      (Array.isArray(detalles) ? detalles : []).reduce((tot, d) => tot + Number(d?.precio ?? 0), 0);

    // Cargar presupuestos
    const cargarPresupuestos = async () => {
      try {
        const response = await presupuestoService.getAllPresupuestos();
        presupuestos.value = (response || []).map(p => ({
          ...p,
          fechaCreacion: new Date(p.fechaCreacion)
        }));
      } catch (error) {
        console.error("Error al cargar presupuestos:", error);
      }
    };

    // Filtros fecha
    const filtrarPorFecha = () => {
      if (!fechaInicio.value || !fechaFin.value) {
        console.warn('Debe seleccionar ambas fechas para filtrar');
        return;
      }
      const inicio = new Date(fechaInicio.value);
      const fin = new Date(fechaFin.value);
      fin.setDate(fin.getDate() + 1);
      filtrosActivos.value = true;

      presupuestos.value = presupuestos.value.filter(p => {
        const f = new Date(p.fechaCreacion);
        return f >= inicio && f <= fin;
      });
      paginaActual.value = 1;
    };

    const resetearFiltros = () => {
      fechaInicio.value = '';
      fechaFin.value = '';
      filtrosActivos.value = false;
      cargarPresupuestos();
    };

    // Paginación
    const presupuestosPaginados = computed(() => {
      const start = (paginaActual.value - 1) * itemsPorPagina.value;
      const end = start + Number(itemsPorPagina.value);
      return presupuestos.value.slice(start, end);
    });
    const totalPaginas = computed(() =>
      Math.ceil(presupuestos.value.length / Number(itemsPorPagina.value))
    );
    const cambiarItemsPorPagina = () => (paginaActual.value = 1);
    const paginaAnterior = () => { if (paginaActual.value > 1) paginaActual.value--; };
    const paginaSiguiente = () => { if (paginaActual.value < totalPaginas.value) paginaActual.value++; };
    const irAPagina = (p) => (paginaActual.value = p);

    const eliminarPresupuesto = async (id) => {
      try {
        await presupuestoService.deletePresupuesto(id);
        presupuestos.value = presupuestos.value.filter(p => p.id !== id);
      } catch (e) {
        console.error("Error al eliminar el presupuesto:", e);
      }
    };
    const deleteModal = async (presupuesto) => {
      modal.value = await modalComponent.value.getModal(presupuesto);
    };

    // ===== Helpers PDF (los mismos que venías usando) =====
    const loadImageInfo = async (url) => {
      try {
        if (!url || !String(url).trim()) return null;
        const res = await fetch(url, { mode: "cors" });
        if (!res.ok) return null;
        const blob = await res.blob();
        const toDataURL = (b) =>
          new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => resolve(fr.result);
            fr.onerror = reject;
            fr.readAsDataURL(b);
          });
        const dataUrl = await toDataURL(blob);
        const dims = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () =>
            resolve({ w: img.naturalWidth || img.width, h: img.naturalHeight || img.height });
          img.onerror = () => resolve({ w: 0, h: 0 });
          img.src = dataUrl;
        });
        return { dataUrl, ...dims };
      } catch { return null; }
    };
    const imageFormatFromDataUrl = (dataUrl) =>
      dataUrl?.startsWith("data:image/png") ? "PNG" : "JPEG";
    const drawTextBlock = (doc, text, x, y, maxWidth, lineHeight = 5) => {
      if (!text) return y;
      const lines = doc.splitTextToSize(String(text), maxWidth);
      lines.forEach((line, i) => doc.text(line, x, y + i * lineHeight));
      return y + lines.length * lineHeight;
    };
    const numeroAPalabrasES = (n) => {
      n = Math.floor(Math.abs(Number(n) || 0));
      if (n === 0) return "PESOS CERO";
      const u = ["","UNO","DOS","TRES","CUATRO","CINCO","SEIS","SIETE","OCHO","NUEVE"];
      const e = ["DIEZ","ONCE","DOCE","TRECE","CATORCE","QUINCE","DIECISÉIS","DIECISIETE","DIECIOCHO","DIECINUEVE"];
      const d = ["","DIEZ","VEINTE","TREINTA","CUARENTA","CINCUENTA","SESENTA","SETENTA","OCHENTA","NOVENTA"];
      const c = ["","CIENTO","DOSCIENTOS","TRESCIENTOS","CUATROCIENTOS","QUINIENTOS","SEISCIENTOS","SETECIENTOS","OCHOCIENTOS"];
      const decenas = (num)=> num<10?u[num]:num<20?e[num-10]:num<30?(num===20?"VEINTE":"VEINTI"+u[num-20].toLowerCase()):(()=>{
        const t=Math.floor(num/10),r=num%10;return r?`${d[t]} Y ${u[r]}`:d[t];
      })();
      const centenas = (num)=> num===100?"CIEN":(()=>{
        const t=Math.floor(num/100),r=num%100;return [c[t], typeof r==="number"?decenas(r):""].filter(Boolean).join(" ").trim();
      })();
      const seccion=(num,div,sing,plur)=>{const cant=Math.floor(num/div);const resto=num-cant*div;
        const texto=cant===0?"":cant===1?sing:`${numeroAPalabrasES(cant).replace(/^PESOS\s+/,"")} ${plur}`;return{texto,resto}};
      let palabras=[],tmp=n;
      const {texto:mill,resto:rMill}=seccion(tmp,1_000_000,"UN MILLÓN","MILLONES"); if(mill) palabras.push(mill); tmp=rMill;
      const {texto:miles,resto:rMil}=seccion(tmp,1000,"MIL","MIL"); if(miles) palabras.push(miles); tmp=rMil;
      if(tmp>0) palabras.push(tmp<100?decenas(tmp):centenas(tmp));
      return ("PESOS "+palabras.join(" ").replace(/\s+/g," ").trim()).toUpperCase();
    };
    const PDF_STYLE = {
      LOGO_MAX_W: 48, LOGO_MAX_H: 14, LOGO_MIN_W: 18, LOGO_MIN_H: 8,
      HEADER_GAP: 3, LOGO_INSET_X: -4, LOGO_INSET_Y: -2,
      BOX_W: 190, BOX_H: 180, BOX_RADIUS: 2, BOX_LINE_WIDTH: 0.35,
      BOX_LINE_COLOR: "#9ca3af", BOX_PADDING: 6, PAGE_MARGIN_X: 10, PAGE_MARGIN_Y: 10, BOX_GAP_Y: 5,
    };

    // ====== PDF que usa tenantInfo/currentUser (no requiere args externos) ======
    const generarPDF = async (presupuesto) => {
      try {
        if (!tenantInfo.value) await loadUsuarioYTenant();

        const t = tenantInfo.value || {};
        const empresa = {
          nombre: (t.nombreEmpresa || t.name || "—").toString().trim(),
          legajo: t.legajo || "",
          domicilio: t.direccionFiscal || "",
          localidad: t.localidad || "",
          telefono: t.telefono || "",
          web: t.web || "",
          email: t.email || currentUser.value?.email || "",
          cuit: t.cuit || "",
          iibb: t.numeroIIBB || "",
          iva: t.condicionIVA || "",
          inicioActividades: t.inicioActividades || "",
          bannerUrl: (t.bannerUrl || "").toString().trim(),
        };

        // Logo (opcional)
        const logoInfo = empresa.bannerUrl ? await loadImageInfo(empresa.bannerUrl) : null;

        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
        const ARS = (n) => Number(n ?? 0).toLocaleString("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 });

        // Mapear filas
        const mapDetalle = (d) => {
          const cantidad = Number(d?.cantidad ?? d?.cant ?? d?.plazas ?? 1);
          const totalExplicito = Number(d?.total ?? d?.precioTotal);
          const unitExplicito = Number(d?.precioUnitario ?? d?.precio_unitario);
          const precio = Number(d?.precio);
          let unit = 0, total = 0;
          if (!Number.isNaN(unitExplicito) && unitExplicito > 0) { unit = unitExplicito; total = unit * cantidad; }
          else if (!Number.isNaN(totalExplicito) && totalExplicito > 0) { total = totalExplicito; unit = cantidad > 0 ? total / cantidad : total; }
          else { unit = precio || 0; total = unit * cantidad; }
          const nombre = d?.servicio?.nombre ?? d?.nombre ?? "";
          const descRaw = String(d?.descripcion ?? d?.Descripcion ?? d?.descripcionLibre ?? "").trim();
          const desc = [nombre, descRaw].filter(Boolean).join(": ");
          return { desc, cantidad, unit, total };
        };

        const filas = Array.isArray(presupuesto?.detalles) && presupuesto.detalles.length
          ? presupuesto.detalles.map(mapDetalle)
          : [{ desc: "—", cantidad: 0, unit: 0, total: 0 }];

        const subtotal = filas.reduce((acc, f) => acc + (Number(f.total) || 0), 0);
        const ajustes = Number(presupuesto?.ajustes ?? presupuesto?.ajuste ?? presupuesto?.ajustesImporte ?? 0);
        const totalGrupo = subtotal + ajustes;

        // Cabecera de presupuesto
        const fechaCreacion = presupuesto?.fechaCreacion instanceof Date
          ? presupuesto.fechaCreacion
          : (presupuesto?.fechaCreacion ? new Date(presupuesto.fechaCreacion) : new Date());
        const fechaTexto = fechaCreacion.toLocaleDateString("es-AR");
        const dirigidoA = presupuesto?.nombre ?? presupuesto?.clienteNombre ?? "";
        const numeroPresu = presupuesto?.codigo ?? presupuesto?.numero ?? "";
        const fechaVenc = presupuesto?.fechaVencimiento ? String(presupuesto.fechaVencimiento) : "";
        const empresaClienteNombre = presupuesto?.empresaNombre ?? "";
        const empresaClienteCUIT = presupuesto?.empresaCUIT ?? "";
        const direccionPostal = presupuesto?.direccionPostal ?? "";
        const codigoPostal = presupuesto?.codigoPostal ?? "";
        const ciudadProv = [presupuesto?.ciudad ?? "", presupuesto?.provincia ?? ""]
          .filter(Boolean).join(" (") + (presupuesto?.provincia ? ")" : "");

        // Dibujo
        const startX = PDF_STYLE.PAGE_MARGIN_X;
        const startY = PDF_STYLE.PAGE_MARGIN_Y;
        const BOX_W  = PDF_STYLE.BOX_W;
        const BOX_H  = PDF_STYLE.BOX_H;
        const PADDING = PDF_STYLE.BOX_PADDING;

        const drawHeader = (x, y, w) => {
          let bottomY;
          if (logoInfo?.dataUrl && logoInfo.w > 0 && logoInfo.h > 0) {
            const maxW = PDF_STYLE.LOGO_MAX_W, maxH = PDF_STYLE.LOGO_MAX_H;
            const ratio = Math.min(maxW / logoInfo.w, maxH / logoInfo.h);
            const imgW = Math.max(PDF_STYLE.LOGO_MIN_W, Math.min(maxW, logoInfo.w * ratio));
            const imgH = Math.max(PDF_STYLE.LOGO_MIN_H, Math.min(maxH, logoInfo.h * ratio));
            const logoX = x + (PDF_STYLE.LOGO_INSET_X || 0);
            const logoY = y + (PDF_STYLE.LOGO_INSET_Y || 0);
            doc.addImage(logoInfo.dataUrl, imageFormatFromDataUrl(logoInfo.dataUrl), logoX, logoY, imgW, imgH);
            bottomY = logoY + imgH + PDF_STYLE.HEADER_GAP;
          } else {
            doc.setFont("helvetica", "bold"); doc.setFontSize(14);
            doc.text(empresa.nombre || "—", x, y + 10);
            bottomY = y + 14;
          }

          const leftX = x, rightX = x + w;
          let leftY = bottomY, rightY = bottomY;

          doc.setFont("helvetica", "normal"); doc.setFontSize(8);
          if (empresa.legajo) leftY = drawTextBlock(doc, `Legajo: ${empresa.legajo}`, leftX, leftY, w * 0.6);
          if (empresa.domicilio) leftY = drawTextBlock(doc, empresa.domicilio, leftX, leftY + 1, w * 0.6);
          const locTel = [empresa.localidad, empresa.telefono].filter(Boolean).join(" • ");
          if (locTel) leftY = drawTextBlock(doc, locTel, leftX, leftY + 1, w * 0.6);
          const webMail = [empresa.web, empresa.email].filter(Boolean).join("  ");
          if (webMail) leftY = drawTextBlock(doc, webMail, leftX, leftY + 1, w * 0.6);

          doc.setFont("helvetica", "bold"); doc.setFontSize(11);
          doc.text(`Presupuesto ${numeroPresu || ""}`, rightX, rightY, { align: "right" }); rightY += 6;

          doc.setFont("helvetica", "normal"); doc.setFontSize(9);
          doc.text(`Fecha: ${fechaTexto}`, rightX, rightY, { align: "right" }); rightY += 5;
          if (fechaVenc) { doc.text(`Vence: ${fechaVenc}`, rightX, rightY, { align: "right" }); rightY += 5; }
          if (empresa.cuit) { doc.text(`CUIT: ${empresa.cuit}`, rightX, rightY, { align: "right" }); rightY += 5; }
          if (empresa.iibb) { doc.text(`Nro.IIBB: ${empresa.iibb}`, rightX, rightY, { align: "right" }); rightY += 5; }
          if (empresa.inicioActividades) { doc.text(`Inicio Act.: ${empresa.inicioActividades}`, rightX, rightY, { align: "right" }); rightY += 5; }

          return Math.max(leftY, rightY) + 8;
        };

        const drawDatosCliente = (x, y, w) => {
          doc.setFont("helvetica", "bold"); doc.setFontSize(9);
          doc.text("Detalle de servicios incluidos:", x, y); y += 7;

          doc.setFont("helvetica", "normal"); doc.setFontSize(8);
          const fila = (label, value) => { if (!value) return;
            doc.setFont("helvetica", "normal"); doc.text(label, x, y);
            doc.setFont("helvetica", "bold"); doc.text(String(value), x + w * 0.38, y); y += 5; };

          fila("Fecha presupuesto:", fechaTexto);
          fila("Dirigido a:", dirigidoA);
          fila("N.º de Presupuesto:", numeroPresu);
          fila("Fecha de vencimiento:", fechaVenc);
          fila("Nombre de la empresa / CUIT:",
            [empresaClienteNombre, empresaClienteCUIT ? `CUIT: ${empresaClienteCUIT}` : ""].filter(Boolean).join(" - "));
          fila("Dirección postal:", direccionPostal);
          const cpCiudad = [codigoPostal, ciudadProv].filter(Boolean).join(" ");
          if (cpCiudad) fila("Código postal / Ciudad (Provincia):", cpCiudad);

          return y + 1;
        };

        const drawTabla = (x, y, w) => {
          const colDesc = 0.54 * w, colCant = 0.12 * w, colUnit = 0.16 * w, colTot = 0.18 * w;
          doc.setFont("helvetica", "bold"); doc.setFontSize(9);
          doc.setDrawColor(187, 187, 187); doc.setFillColor(242, 242, 242);
          doc.rect(x, y, w, 7, "FD");
          doc.text("Descripción de servicios a prestar", x + 2, y + 5);
          doc.text("Cantidad", x + colDesc + colCant - 2, y + 5, { align: "right" });
          doc.text("Precio unitario", x + colDesc + colCant + colUnit - 2, y + 5, { align: "right" });
          doc.text("Precio total", x + w - 2, y + 5, { align: "right" });

          y += 8; doc.setFont("helvetica", "normal"); doc.setFontSize(8);
          const lineH = 6, maxY = startY + BOX_H - 30;

          for (const f of filas) {
            if (y + lineH > maxY) break;
            const descLines = doc.splitTextToSize(f.desc || "—", colDesc - 4);
            const rowH = Math.max(lineH, descLines.length * 4.2);
            doc.setDrawColor(187, 187, 187); doc.rect(x, y - 1, w, rowH + 2, "S");
            let yy = y + 3; descLines.forEach(line => { doc.text(line, x + 2, yy); yy += 4.2; });
            doc.text(String(Number(f.cantidad)||0), x + colDesc + colCant - 2, y + 4, { align: "right" });
            doc.text(Number(f.unit).toLocaleString("es-AR", { minimumFractionDigits: 2 }), x + colDesc + colCant + colUnit - 2, y + 4, { align: "right" });
            doc.text(Number(f.total).toLocaleString("es-AR", { minimumFractionDigits: 2 }), x + w - 2, y + 4, { align: "right" });
            y += rowH + 3;
          }
          return y;
        };

        const drawTotales = (x, y, w) => {
          const label = (txt, offY = 0, bold = false) => { doc.setFont("helvetica", bold ? "bold" : "normal"); doc.text(txt, x + w - 60, y + offY, { align: "left" }); };
          const value = (txt, offY = 0, bold = false) => { doc.setFont("helvetica", bold ? "bold" : "normal"); doc.text(txt, x + w - 2, y + offY, { align: "right" }); };

          label("Subtotal"); value(ARS(subtotal));
          label("Ajustes", 6); value(ARS(ajustes), 6);
          doc.setDrawColor(187, 187, 187); doc.line(x + w - 62, y + 8, x + w, y + 8);
          label("Precio total del grupo", 12, true); value(ARS(totalGrupo), 12, true);
        };

        // Caja
        const drawCaja = (x, y) => {
          const w = BOX_W, h = BOX_H;
          doc.setLineWidth(PDF_STYLE.BOX_LINE_WIDTH);
          doc.setDrawColor(156, 163, 175);
          doc.roundedRect(x, y, w, h, PDF_STYLE.BOX_RADIUS, PDF_STYLE.BOX_RADIUS, "S");

          const mx = x + PADDING, my = y + PADDING, iw = w - PADDING * 2;
          const y0 = drawHeader(mx, my, iw);
          const y1 = drawDatosCliente(mx, y0 + 2, iw);
          drawTabla(mx, y1 + 2, iw);
          drawTotales(mx, y + h - 22, iw);
        };

        drawCaja(PDF_STYLE.PAGE_MARGIN_X, PDF_STYLE.PAGE_MARGIN_Y);
        const fileName = `presupuesto_${presupuesto?.codigo || "sin_codigo"}.pdf`;
        doc.save(fileName);
      } catch (e) {
        console.error("Error al generar el PDF:", e);
        alert("No se pudo generar el PDF. Revisá la consola para más detalles.");
      }
    };

    onMounted(async () => {
      await loadUsuarioYTenant();    // 👈 ahora sí tenemos perfil/tenant
      await cargarPresupuestos();    // y cargamos los presupuestos
    });

    return {
      // estado
      presupuestos, fechaInicio, fechaFin, filtrosActivos,
      itemsPorPagina, paginaActual, modalComponent, presupuestosPaginados, totalPaginas,
      // helpers
      formatMoney, formatFecha, calcularTotalPresupuesto,
      // filtros/paginación
      filtrarPorFecha, resetearFiltros, cambiarItemsPorPagina, paginaAnterior, paginaSiguiente, irAPagina,
      // acciones
      deleteModal, eliminarPresupuesto, generarPDF,
      // perfil (por si querés mostrar algo en UI)
      currentUser, tenantInfo,
    };
  }
};
</script>
